var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warningZone)?_c('v-snackbar',{staticStyle:{"z-index":"2000"},attrs:{"timeout":-1,"value":true,"absolute":"","centered":"","color":"light-blue accent-2","elevation":"24"},model:{value:(_vm.warningZone),callback:function ($$v) {_vm.warningZone=$$v},expression:"warningZone"}},[_vm._v(" It seems like you're inactive for a while. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }